import api from '../utils/api';

/**
 * Delivery Note Service
 * บริการสำหรับการจัดการใบส่งของชั่วคราว
 */

// Get all delivery notes with pagination and filters
export const getDeliveryNotes = async (page = 1, limit = 10, search = '', status = '', contact_id = '') => {
  try {
    const response = await api.get('/api/delivery-notes', {
      params: { page, limit, search, status, contact_id }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get delivery note by ID
export const getDeliveryNoteById = async (id) => {
  try {
    const response = await api.get(`/api/delivery-notes/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Create new delivery note
export const createDeliveryNote = async (data) => {
  try {
    const response = await api.post('/api/delivery-notes', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update delivery note
export const updateDeliveryNote = async (id, data) => {
  try {
    const response = await api.put(`/api/delivery-notes/${id}`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Delete delivery note
export const deleteDeliveryNote = async (id) => {
  try {
    const response = await api.delete(`/api/delivery-notes/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * แปลงใบเสนอราคาเป็นใบส่งของชั่วคราว
 * @param {number} quoteId - ID ของใบเสนอราคา
 * @param {object} data - ข้อมูลเพิ่มเติม { issue_date, due_date, notes, status }
 * @returns {Promise}
 */
export const convertQuoteToDeliveryNote = async (quoteId, data = {}) => {
    try {
        const response = await api.post(`/api/delivery-notes/convert-from-quote/${quoteId}`, data);
        return response.data;
    } catch (error) {
        console.error('Error converting quote to delivery note:', error);
        throw error;
    }
};
